<template lang="pug">
.DeliveryTime.pt-4(:class="{ 'pb-4': !full, disable: disable }" data-qa="delivery-time-container")
  h3.text-lg.font-medium.pb-3(class="lg1024:text-xl") {{ $t('ORDER_DELIVERY_PERIOD') }}
  .grid.grid-cols-2.gap-4.w-full(:class="['max-sm:grid-cols-1', { 'lg1024:w-4/4' : !full }]")
    UiSelect.delivery-time__select-day(v-model="day" :options="options" data-qa="delivery-time-day-input")
    UiSelect.delivery-time__select-time(v-model="time" :options="times" data-qa="delivery-time-time-input")
</template>

<script setup>
// pug-шаблон невидим для vue-eslint-parser — использование в нём не распознаётся
// eslint-disable-next-line no-unused-vars
import UiSelect from '@/components/ui/UiSelect.vue'
import { useDeliveryIntervals } from '@/steps/step4/composables/useDeliveryIntervals'

defineOptions({ name: 'DeliveryTimeIntervals' })

const props = defineProps({
  disable: {
    type: Boolean,
    default: false,
  },
  mkad: {
    type: Boolean,
    default: false,
  },
  full: {
    type: Boolean,
    default: false,
  },
  deliveryTimes: {
    type: Object,
    required: true,
  },
  deliveryServiceId: {
    type: String,
    required: true,
  },
})

const emit = defineEmits(['time', 'deliveryTime', 'expressDisabled'])

// eslint-disable-next-line no-unused-vars -- биндинги уходят в pug-шаблон
const { options, day, time, times } = useDeliveryIntervals(props, emit)
</script>

<style lang="scss">
.DeliveryTime {
  &.disable {
    pointer-events: none;
    opacity: 0.2;
  }

  select {
    height: 44px !important;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    background: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgZmlsbD0iY3VycmVudENvbG9yIiBjbGFzcz0iYmkgYmktY2hldnJvbi1kb3duIiB2aWV3Qm94PSIwIDAgMTYgMTYiPjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTEuNjQ2IDQuNjQ2YS41LjUgMCAwIDEgLjcwOCAwTDggMTAuMjkzbDUuNjQ2LTUuNjQ3YS41LjUgMCAwIDEgLjcwOC43MDhsLTYgNmEuNS41IDAgMCAxLS43MDggMGwtNi02YS41LjUgMCAwIDEgMC0uNzA4eiIvPjwvc3ZnPg==')
      no-repeat;
    background-size: 16px 16px;
    background-position: 96% 50%;
    padding: 10px 28px 10px 12px;
    cursor: pointer;
    border: 2px solid #d1d8dd;

    @media (max-width: 480px) {
      border: 1px solid #d1d8dd;
      border-radius: 8px;
    }

    &:focus {
      border: 2px solid #858c91;
      outline: none;

      @media (max-width: 480px) {
        border: 1px solid #858c91;
      }
    }
  }
}
</style>
